import lodash from 'lodash';
import store from 'redux/store';
import { accessType } from 'constants/index';
import { partnerAdmin } from '../../constants/roles';
import stringUtil from '../stringUtil';
import arrayUtil from '../array';


// Returns 'true' if there is at least one userRole IN rolesVisibleTo
const userRolesInRolesVisibleTo = (userRoles = [], rolesVisibleTo = []) => {
   let userHasRoleInRolesVisibleTo = false;

   if (userRoles && rolesVisibleTo) {
      for (let i = 0; i < userRoles.length; ++i) {
         if (rolesVisibleTo.indexOf(userRoles[i]) > -1) {
            userHasRoleInRolesVisibleTo = true;
            break;
         }
      }
   }

   return userHasRoleInRolesVisibleTo;
};

const hasRoleAccess = (accessValue, userRoleListEmployer, userRoleListPartner) => {
   let hasEmployerRoleAccess = false;
   let hasPartnerRoleAccess = false;

   if (lodash.isArray(accessValue?.employer)) {
      hasEmployerRoleAccess = userRolesInRolesVisibleTo(userRoleListEmployer, accessValue.employer);
   }

   if (lodash.isArray(accessValue?.partner)) {
      hasPartnerRoleAccess = userRolesInRolesVisibleTo(userRoleListPartner, accessValue.partner);
   }

   return [hasEmployerRoleAccess, hasPartnerRoleAccess];
};

const hasPrivilegeAccessEmployer = (userEmployerPrivileges = null, privilegeKeyStr) => {
   const hasEmployerPrivilegesLoaded = userEmployerPrivileges !== null;
   const hasEmployerPrivilegeAccess = hasEmployerPrivilegesLoaded
                           && Object.prototype.hasOwnProperty.call(userEmployerPrivileges, privilegeKeyStr)
                           && userEmployerPrivileges[privilegeKeyStr];
   return hasEmployerPrivilegeAccess;
};


// Returns true or false if user has access with given access Property
const hasAuthAccessBase = ({
   access,
   userRoleListEmployer,
   userRoleListPartner,
   userEmployerPrivileges,
}) => {
   const hasAccessDefined = access !== undefined;
   let hasAccess = false;

   if (hasAccessDefined) {
      let hasEmployerRoleAccess = false;
      let hasPartnerRoleAccess = false;
      let hasEmployerPrivilegeAccess = false;

      switch (access?.type) {
         case accessType.role:
            [hasEmployerRoleAccess, hasPartnerRoleAccess] = hasRoleAccess(
               access?.value,
               userRoleListEmployer,
               userRoleListPartner,
            );
            hasEmployerPrivilegeAccess = true;
            break;
         case accessType.privilege:
            hasEmployerPrivilegeAccess = hasPrivilegeAccessEmployer(userEmployerPrivileges, access?.value);
            hasPartnerRoleAccess = true;
            hasEmployerRoleAccess = true;
            break;
         case accessType.public:
            hasEmployerRoleAccess = true;
            hasPartnerRoleAccess = true;
            hasEmployerPrivilegeAccess = true;
            break;
         default:
            throw new Error(`access property=${ JSON.stringify(access, undefined, 2) } did not have any type match.`);
      }
      hasAccess = (hasEmployerRoleAccess || hasPartnerRoleAccess) && hasEmployerPrivilegeAccess;
   } else {
      hasAccess = true;
   }

   return hasAccess;
};

const hasAuthAccess = (access = undefined) => {
   let hasAccess;

   if (access === undefined) {
      hasAccess = true;
   } else {
      const state = store.getState();
      const userRoleListEmployer = state?.authReducer?.loggedInUser?.roles || [];
      const userRoleListPartner = state?.authReducer?.loggedInUserPartner?.roles || [];
      const userEmployerPrivileges = state?.privilegeReducer?.privileges || null;

      hasAccess = hasAuthAccessBase({
         access,
         userRoleListEmployer,
         userRoleListPartner,
         userEmployerPrivileges,
      });
   }

   return hasAccess;
};

const getSubAppNamePathByPathname = (pathname) => {
   if (!lodash.isString(pathname)) {
      throw new TypeError('Invalid argument type. Must be string.');
   }

   const separatedPathnameList = (pathname.split('/').filter((item) => item));
   if (separatedPathnameList.length > 0) {
      return separatedPathnameList[0];
   } else {
      throw new Error('Unable to extract sub-app path from the pathname');
   }
};

// Returns the list of admin roles given the path name
const getAdminRoleListByPathname = (pathname) => {
   let adminRoleList = [];

   const subAppName = getSubAppNamePathByPathname(pathname);
   const camelCaseSubAppName = subAppName && stringUtil.hyphenToCamelCase(subAppName);

   if (
      camelCaseSubAppName
      && lodash.isPlainObject(partnerAdmin)
      && Object.prototype.hasOwnProperty.call(partnerAdmin, camelCaseSubAppName)
   ) {
      adminRoleList = partnerAdmin[camelCaseSubAppName];
   }

   return adminRoleList;
};

const isUserAdminByPathname = (pathname) => {
   const adminRoleListByPathName = getAdminRoleListByPathname(pathname);
   const userPartnerRoleList = (store.getState())?.authReducer?.loggedInUserPartner?.roles || [];
   return arrayUtil.hasIntersection(adminRoleListByPathName, userPartnerRoleList);
};


export default {
   hasAuthAccess,
   hasAuthAccessBase,
   userRolesInRolesVisibleTo,
   hasRoleAccess,
   hasPrivilegeAccessEmployer,
   isUserAdminByPathname,
};
